import React from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import { FBasicPropos } from '../../../interfaces/User.interface';
import { Controller } from 'react-hook-form';

export interface Item {
    [key: string]: any;  // This allows any key with any type of value
}

const FAutoComplete: React.FC<FBasicPropos & {
    onFieldChange?: (fieldName: string, value: any) => void;
}> = ({
    field, control, errors, errorMessage, onFieldChange
}) => {
    const { name, editable, data, props } = field;
    if (!errorMessage) errorMessage = errors[name]?.message as string;

    return (
        <Controller
            name={name}
            control={control}
            // defaultValue={preFilled || defaultValue || null}
            render={({ field: controllerField }) => (
                <Autocomplete
                    {...controllerField}
                    value={controllerField.value || null}
                    options={data || []}
                    autoHighlight
                    getOptionLabel={(option: any) => option}
                    onChange={(event, newValue) => {
                        controllerField.onChange(newValue);
                        onFieldChange?.(name, newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(props?.freeSolo) controllerField.onChange(newInputValue);
                        // console.log('onInputChange triggered:', newInputValue);
                      }}
                      disabled={editable === false}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            error={!!errorMessage}
                            helperText={errorMessage}
                            label={field.question}
                            margin="normal"

                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                            {...props}
                            // required={field.required}
                        />
                    )}
                    {... (props || {})}
                />
            )}
        />
    );
}

export default FAutoComplete;
